import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Row } from 'react-bootstrap';
const orderBy = require('lodash/orderBy');

import AccessButton from '../common/AccessButton';
import DateString from '../common/DateString';
import ActivityIcon from '../activity/ActivityIcon';
const SortUtil = require('../../util/SortUtil');

const propTypes = {
    className: PropTypes.string,
    shortCourses: PropTypes.array.isRequired,
    filterActive: PropTypes.bool.isRequired,
    shortCourseMatchesFilter: PropTypes.func.isRequired,
    sortObj: SortUtil.SortObjPropType.isRequired,
    channelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    depth: PropTypes.number,
};

const defaultProps = {
    className: '',
    depth: 0,
};

function ProjectShortCourseList(props) {
    if (!props.shortCourses) {
        return null;
    }

    // this sortObj is set up to work using keys of project object.
    // modified & created_at are keys which also belong to the activity object
    // and should be sorting using these keys if present.
    // if neither, sort by activity name
    let sortedShortCourses;
    if (props.sortObj.key === 'modified_at' || props.sortObj.key === 'created_at') {
        sortedShortCourses = SortUtil.sortObjectArray(props.shortCourses, props.sortObj);
    }
    else {
        sortedShortCourses = orderBy(props.shortCourses, (sc) => sc.title.toLowerCase());
    }

    return (
        <ul>
            {sortedShortCourses.map((sc) => {
                const scViewHref = `/project/${props.channelId}/${sc.project_id}/short_course/${sc.id}`;

                return (
                    <li className={`activityListItem ${props.filterActive && props.shortCourseMatchesFilter(sc) ? 'highlight' : ''} ${props.className}`} key={sc.id}>
                        <Row className="activityListItem__wrapper">
                            <Link to={scViewHref} className={`col-3 col-sm-2 col-md-1 activityListItem__col--control activityListItem__col--depth-${props.depth} nowrap`}>
                                <div className="listDepthWrapper">
                                    {/*<ActivityIcon className="nav-menu-act-image" activity={activity} />*/}
                                </div>
                            </Link>
                            <Link to={scViewHref} className="activityListItem__col--clipText col-7 col-sm-7 col-md-5 col-lg-3 link-plain link-body-color">
                                <div title={sc.title}>{sc.title}</div>
                            </Link>
                            <Link to={scViewHref} className="activityListItem__col d-none d-md-flex col-md-2 col-lg-2 link-plain link-body-color nowrap text-md">
                                <DateString shortMonth date={sc.created_at} />
                            </Link>
                            <Link to={scViewHref} className="activityListItem__col d-none d-md-flex col-md-2 col-lg-2 link-plain link-body-color nowrap text-md">
                                { sc.modified_at ?
                                    <DateString shortMonth date={sc.modified_at} />
                                    :
                                    'Never'
                                }
                            </Link>
                            <div className="activityListItem__col d-none d-lg-flex col-lg-4">
                                {/*TODO: check canPreview permission*/}
                                {/*<AccessButton
                                    className="margin-left-xl"
                                    iconPath={`${GlobalConfig.StaticUrl}/img/Play.svg`}
                                    iconStyle={{width:'24px'}}
                                    text="preview"
                                    href={`/project/${activity.owner_id}/${activity.project_id}/activity/${activity.id}/preview`}
                                />*/}
                            </div>
                        </Row>
                    </li>
                );
            })}
        </ul>
    );
}

ProjectShortCourseList.propTypes = propTypes;
ProjectShortCourseList.defaultProps = defaultProps;

export default ProjectShortCourseList;
